import React, { Component } from 'react';
import { Form, Input, Button } from 'antd';
import './expenses.less';

const FormItem = Form.Item;

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  onChange = e => {
    this.props.onChange(e.target.value);
  };

  onSearch = () => {
    const data = this.props.form.getFieldsValue();
    const params = {
      name: data.name || '',
    };
    this.props.onSearch(params);
  };

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className="expense-search-form">
        <Form layout="inline" style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('name', {
              initialValue: this.props.name || null,
            })(<Input placeholder="请输入任务名称搜索" />)}
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={this.onSearch}>
              搜索
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/task/taskCheck/FormSearch.js